import { render, staticRenderFns } from "./DeleteUser.html?vue&type=template&id=7102963a&scoped=true&"
import script from "./DeleteUser.js?vue&type=script&lang=js&"
export * from "./DeleteUser.js?vue&type=script&lang=js&"
import style0 from "./DeleteUser.scss?vue&type=style&index=0&id=7102963a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102963a",
  null
  
)

export default component.exports